// extracted by css-extract-rspack-plugin
export default {"root":"BW4Dr"};